import axios from 'axios'

// ** Get Profile Item
export const getProfileItem = (id) => {
    return dispatch => {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const userId = id || userData?.id
        if (!userId) return
        return axios.get(`/api/user/${userId}`).then(response => {
            dispatch({
                type: 'GET_PROFILE_ITEM',
                data: response.data?.user || response.data?.message
            })
            const localUserData = JSON.parse(localStorage.getItem('userData')) || {}
            const profileRawData = response.data.user || response.data.message || {}
            const standardizedId = profileRawData.user_id || localUserData.id || profileRawData.id
            
            const payload = {
                ...localUserData,
                ...profileRawData,
                id: standardizedId,
                tenantId: profileRawData.tenant_id || localUserData.tenantId
            }
            
            delete payload.user_id
            delete payload.userid
            
            localStorage.setItem('userData', JSON.stringify(payload))
            return response.data
        })
    }
}
// ** Get Pubic Profile Item
export const getPublicProfileItem = ( { slug } ) => {
    return dispatch => {
        return axios.get(`/api/v3/user/profile/${slug}`).then(response => {
            dispatch({
                type: 'GET_PROFILE_ITEM',
                data: response.data
            })
            return response.data
        })
    }
}
export const deleteProfileIcon = ({ id }) => {
    return dispatch => {
        return axios.delete(`/api/user/${id}/profile-image`)
    }
}
// ** Get Profile Detail
export const getProfileDetail = ({ id }) => {
    return async dispatch => {
        return await axios.get(`/api/user/${id}`).then(response => response.data)
    }
}
// ** Update Profile Item
export const updateProfile = ({ id }, data) => {

    return dispatch => {
        return axios.post(`/api/user/${id}`, data)
    }
}

export const updateProfilePhoto = ({ id }, data) => {
    return dispatch => {
        const form = new FormData()
        form.append('image', data.file || data.image)
        return axios.patch(`/api/user/${id}/profile-image`, form, { headers: { "Content-Type": "multipart/form-data" } })
    }
}
export const updateAccount = ({ id }, data) => {
    return dispatch => {
        return axios.post(`/api/user/${id}`, data)
    }
}

export const postExitSurvey = ({ id }, data) => {

    return dispatch => {
        return axios.post(`/api/v3/user/exitSurvey`, data, { params : {userId: id }})
    }
}